<template>
  <div class="booth booth-component wd-1200">

    <moduleTitle :moduleFlag="moduleFlag" />

    <div class="booth-list clearFix" :class="{ 'onlyOne' : moduleInfo.length <= 1 }">
      <div class="booth-container" v-for="(item, index) in moduleInfo" :key="index">
        <img @click="handleToDetail(item)" :src="item.image"/>
      </div>
    </div>
    <div class="more" v-if="isMore">
      <span @click="handleMore">查看更多</span>
    </div>
  </div>
</template>

<script>
  import moduleTitle from '@/components/pc/module-title';

  export default {
    components: { moduleTitle },
    props: {
      moduleInfo: {
        type: Array,
        default: () => []
      },
      moduleFlag: {
        type: String,
        default: '',
      },
      isMore: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
      }
    },
    methods: {
      handleToDetail(item) {
        this.$router.push({
          name: 'booth-detail',
          params: {
            moduleIndex: this.moduleFlag.split('_')[1]
          },
          query: {
            id: item.id
          }
        })
      },
      handleMore() {
        this.$router.push({ 
          name: 'booth',
          params: {
            moduleIndex: this.moduleFlag.split('_')[1]
          }
        })
      }
    },
    created() {
      console.log('booth', this.moduleInfo)
    }
  }
</script>

<style scoped lang="scss">
  .booth {
    overflow: hidden;

    .booth-list {
      display: flex;
      flex-flow: wrap;
      flex-direction: row;
      justify-content: center;

      .booth-container {

        img {
          width: 584px;
          height: 328px;
          display: inline-block;
        }
      }

      .booth-container:nth-of-type(1) {
        padding-right: 30px;
      }
    }

    .onlyOne {
      justify-content: center;
    }
  }
</style>
